// @flow
import type {SagaIterator} from 'redux-saga';

import type {ActionType} from 'constants/flow/flowTypes';
import {MENU} from 'constants/actions';

import {takeEvery, call} from 'redux-saga/effects';
import {disableScroll} from 'libs/disableScroll';

/**
 * Toggles scroll on body based on menu visibility state
 *
 * @param {ActionType<{visible: boolean}>} action - dispatched action
 */
export function* toggleBodyScrollOnMenuVisibilityChange(
    action: ActionType<{visible: boolean}>,
): SagaIterator {
    yield call(disableScroll, action.payload.visible, true);
}

/**
 * App menu saga
 */
export function* menuSaga(): SagaIterator {
    yield takeEvery(MENU.SET_VISIBILITY_MENU, toggleBodyScrollOnMenuVisibilityChange);
}
